import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';
import storageEngine from 'redux-persist/lib/storage';

import { getEnv } from '@shared/utils/env';
import authReducer from './reducers/auth/authReducer';
import cashinReducer from './reducers/cashin/cashinReducer';
import reportReducer from './reducers/common/fileExport';
import correspondentRemittanceReducer from './reducers/correspondent/correspondentReducer';
import remittanceParametersReducer from './reducers/remittance/remittanceParametersReducer';
import subsidiaryReducer from './reducers/subsidiary/subsidiaryReducer';

const storage = storageEngine?.default ?? storageEngine;

const persistConfig = {
  key: 'root',
  whitelist: ['auth'],
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  subsidiary: subsidiaryReducer,
  cashin: cashinReducer,
  correspondentRemittance: correspondentRemittanceReducer,
  remittanceParameters: remittanceParametersReducer,
  report: reportReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: getEnv().VITE_NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export default store;
